// Initialize Firebase
export const config = {
    apiKey: "AIzaSyB3aHPTdtaetoXJ0Rn7eIKgcdcIZYs_bFc",
    authDomain: "fabricademy.firebaseapp.com",
    databaseURL: "https://fabricademy.firebaseio.com",
    projectId: "fabricademy",
    storageBucket: "fabricademy.appspot.com",
    messagingSenderId: "212825573392"
};
